<template>
  <div class="member-server text-left" style="margin-top:0px;">
    <h1 class="member-title member-title2 ">历史代约</h1>
    <div style="padding:10px;">
      <el-timeline>
        <el-timeline-item v-for="(activity, index) in list" :key="index" :timestamp="activity.RegDateTime">
          代约公司『{{activity.CoName}}』的『{{activity.PostName}}』职位，状态：{{_GetResult(activity.IsProcessed,activity.IsContact,activity.LoInterviewID)}}
        </el-timeline-item>
      </el-timeline>
      <div v-if="list.length==0" style="color:#999999;font-size:14px;margin-left:18px;">暂无代约</div>
    </div>

  </div>
</template>

<script type="text/javascript">
  import {
    mapGetters
  } from "vuex";
  import {
    getListByTalent
  } from "~/api/insteadInvite";
  import {
    getInsteadInviteState,
    resumeType2Source
  } from "~/utils";
  export default {
    props: {
      type: {
        type: Number,
        default: 1
      }, //1-乐跳可推荐，2-乐跳历史会员，3-乐跳游客 4-猎头候选人，5-O库人才(Ma...)，6-P1库人才(Mb...)
      id: {
        type: Number,
        default: 0
      } //对应表中的记录ID（MeDataID、MaResumeID、MbResumeID）
    },
    computed: {
      ...mapGetters([
        "vrc" //显示权限代码
      ])
    },
    data() {
      return {
        list: []
      };
    },
    created() {
      var params = {
        resume_source: resumeType2Source(this.$props.type),
        resume_id: this.$props.id
      };
      getListByTalent(params).then(r => {
        if (r.errcode === 0) {
          this.list = r.data;
        } else {
          this.$message.error("获取人才有效代约列表出错！原因：" + r.errmsg);
        }
      });
    },
    methods: {
      MenuClick(itemId) {
        let isOk = true;
        if (isOk) {
          this.$emit("menu-click", itemId);
        } else {
          this.$alert(
            "您目前还<b>没有</b>该项操作的权限，请联系管理员！",
            "提示", {
              dangerouslyUseHTMLString: true,
              confirmButtonText: "返回",
              type: "info"
            }
          );
        }
      },
      _GetResult(a, b, c) {
        return getInsteadInviteState(a, b, c);
      },
    }
  };
</script>

<style scoped>
</style>